<script>
    const {
        avatar,
        message = null,
        name,
        flipLabels = null,
        link = null,
        onClick = null,
    } = $props()

    const greeting = $derived(message ?? getTimeOfDayMessage())

    // A click callback is a side effect, which shouldn't happen on a link
    // (clicking a link should only navigate), so use a button instead.
    const tagName = $derived(getTagName())

    function getTagName() {
        if (onClick) {
            return 'button'
        }

        return link ? 'a' : 'div'
    }

    function handleClick(event) {
        if (onClick) {
            event.preventDefault()
            onClick()
        }
    }

    function getTimeOfDayMessage() {
        const hour = new Date().getHours()
        if (hour >= 6 && hour <= 11) {
            return window.i18n.gettext('Good morning!')
        }
        if (hour >= 12 && hour <= 17) {
            return window.i18n.gettext('Good afternoon!')
        }
        if (hour >= 18 && hour <= 23) {
            return window.i18n.gettext('Good evening!')
        }
        if (hour >= 0 && hour <= 5) {
            return window.i18n.gettext('Good night!')
        }
        return window.i18n.gettext('Good day!')
    }
</script>

<svelte:element
    this={tagName}
    type={onClick ? 'button' : null}
    href={onClick ? null : link}
    class="greeting"
    onclick={handleClick}
>
    {#if avatar}
        <div class="avatar" style:background-image={avatar ? `url('${avatar}')` : null}></div>
    {/if}
    <div
        class="text"
        class:flip={flipLabels}
    >
        <div>{greeting}</div>
        <div>{name}</div>
    </div>
</svelte:element>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.greeting {
  display: flex;
  align-items: center;
  gap: 16px;
  color: #fff;
  text-decoration: none;
  background: none;
  border: 0;
  padding: 0;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.avatar {
  min-width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: currentColor;
  background-size: cover;
  background-position: center;
  border: 1px solid currentColor;
}

.text {
  font-size: 14px;
  font-weight: 400;
  display: flex;
  flex-direction: column;
}
.text.flip {
  flex-direction: column-reverse;
}
.text > div:last-child {
  font-size: 26px;
  font-weight: 600;
}</style>
